import React from 'react';
import { AboutUsDescriptionCard } from '../../../../services/about-us/fetchAboutUsPageContent';
import styled from 'styled-components';
import { COLORS, device } from '../../../../constants';
import { Text } from '../../../../components';
import { ParsedBoldText } from '../../../../components/ ParsedBoldText/ParsedBoldText';
import { SHADOW } from '../../../../constants/animations';
import { MotionGridBlock } from '../../../../components/Motion';

interface DescriptionCardItemProps {
  descriptionCardItem: AboutUsDescriptionCard;
}

const DescriptionCardItem = ({
  descriptionCardItem,
}: DescriptionCardItemProps) => {
  return (
    <DescriptionCardItemWrapper>
      <Text
        text={descriptionCardItem.id.toString().padStart(2, '0')}
        size={70}
        lineHeight={105}
        color={COLORS.RED_PRESSED}
      />
      <DescriptionCardItemLine />
      <ParsedBoldText text={descriptionCardItem.Description} />
    </DescriptionCardItemWrapper>
  );
};

const DescriptionCardItemWrapper = styled(MotionGridBlock)`
  background-color: ${COLORS.WHITE};
  width: 100%;
  max-width: 410px;
  box-sizing: border-box;
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  &:hover {
    background: ${COLORS.GRAY_BG_COLOR};
    box-shadow: ${SHADOW.HOVER.SERVICE_CARD};
  }
  @media screen and ${device.lg} {
    gap: 20px;
    padding: 30px;
    > h4 {
      font-size: 40px;
      line-height: 1.5;
    }
  }
  @media screen and ${device.md} {
    padding: 10px 15px;
    > h4 {
      font-size: 30px;
    }
  }
  @media screen and ${device.sm} {
    > h4 {
      font-size: 40px;
      text-align: center;
    }
  }
`;
const DescriptionCardItemLine = styled.span`
  display: block;
  width: 100%;
  height: 1px;
  background-color: ${COLORS.RED_LINE};
`;
export { DescriptionCardItem };
